var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9591 0C22.1855 0 24 1.81447 24 4.05067V6.11729V17.8897V19.9493C24 22.1855 22.1855 24 19.9591 24H4.04087C1.81447 24 0 22.1855 0 19.9493V17.8897V6.11729V4.05067C0 1.81447 1.81447 0 4.04087 0H19.9591ZM1.76543 5.55367V17.8878C1.76543 17.8884 1.76543 17.889 1.76543 17.8897V19.9493C1.76543 21.0521 2.54638 21.9747 3.58265 22.1881C3.73069 22.2186 3.88394 22.2346 4.04087 22.2346H19.9591C21.2145 22.2346 22.2346 21.2096 22.2346 19.9493L22.2346 17.8897C22.2346 17.889 22.2346 17.8884 22.2346 17.8878V6.11729V4.05067C22.2346 2.79036 21.2145 1.76543 19.9591 1.76543H4.04087C3.09931 1.76543 2.29015 2.34195 1.94442 3.16191C1.82918 3.43523 1.76543 3.73559 1.76543 4.05067L1.76543 5.55367Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4199 12.4626C12.3145 12.4187 12.2157 12.3539 12.13 12.2681L9.2636 9.40174C8.91213 9.05027 8.91213 8.48042 9.2636 8.12895C9.61508 7.77748 10.1849 7.77748 10.5364 8.12895L12.8617 10.4542L17.0523 6.2636C17.4038 5.91213 17.9736 5.91213 18.3251 6.2636C18.6766 6.61508 18.6766 7.18492 18.3251 7.5364L13.5288 12.3328C13.2278 12.6337 12.7669 12.677 12.4199 12.4626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlActive);
export default __webpack_public_path__ + "static/media/control-active.17b767afa8537f5dbab0cfec58de4474.svg";
export { ForwardRef as ReactComponent };